import { ChevronDown } from 'lucide-react';
import Avatar from '../Avatar.jsx';
import Tooltip from '../Tooltip.jsx';
import { topbarChipClass, topbarChipLabelClass } from './topbarClasses.js';

const TopbarChip = ({
  label,
  hideLabelOnMobile = false,
  hideChevronOnMobile = false,
  logo,
  avatarSrc,
  avatarInitials,
  avatarClassName = '',
  showChevron = false,
  rightContent,
  className = '',
  labelMaxWidthClass = '',
  withLabelTooltip = false,
  tooltipContent,
}) => {
  const labelElement = label ? (
    <span
      className={[
        topbarChipLabelClass,
        'block min-w-0 truncate',
        labelMaxWidthClass,
        hideLabelOnMobile ? 'max-md:hidden' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {label}
    </span>
  ) : null;

  const avatarNode = logo || (
    <Avatar
      size="sm"
      src={avatarSrc}
      initials={avatarInitials}
      className={[
        'h-4 w-4 min-h-[1rem] min-w-[1rem] shrink-0 border border-edge',
        avatarClassName,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );

  return (
    <div className={[topbarChipClass, className].filter(Boolean).join(' ')}>
      <span className="inline-flex shrink-0">{avatarNode}</span>
      {labelElement
        ? withLabelTooltip
          ? (
            <Tooltip
              content={tooltipContent || label}
              position="bottom"
              align="start"
              triggerClassName="min-w-0"
              size="compact"
            >
              {labelElement}
            </Tooltip>
          )
          : labelElement
        : null}
      {rightContent ? <span className="inline-flex shrink-0">{rightContent}</span> : null}
      {showChevron ? (
        <ChevronDown
          size={14}
          className={[
            'shrink-0 text-content-muted',
            hideChevronOnMobile ? 'max-md:hidden' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          aria-hidden
        />
      ) : null}
    </div>
  );
};

export default TopbarChip;
